const details = state => state.monitoring.details;

export default {
  details,
};
